export const MIN_LIFETIME_PLAN_DISCOUNTED_PRICE = 19999
export const MIN_NON_ZERO_DISCOUNTED_PRICE = 50
